// MIT's undergraduate Courses, MIT's word for majors (#2596, founder
// 2026-09-30: "majors offered by the college in the public page"). Read on
// 2026-09-30 from the official MIT Course Catalog's Degree Charts index
// (catalog.mit.edu/degree-charts/), Undergraduate Degree Charts half, which
// lists every Course by school; every one leads to the SB (Bachelor of
// Science). The three EECS Courses (6-3, 6-4, 6-5) appear under both the
// School of Engineering and the MIT Schwarzman College of Computing; they are
// listed once, under Engineering, so the College of Computing adds none.
// Graduate degree charts and minors are left out. The catalog writes 6-4 as
// "(6-4)" in one place and "(Course 6-4)" in another; the second is used. No
// flags: the college file holds no programs source. The KB list was the
// starting point; the catalog wins.
const majors = {
    "slug": "massachusetts-institute-of-technology",
    "read": "2026-09-30",
    "intro": "Every undergraduate Course (MIT's word for a major) in the official MIT Course Catalog's degree charts, grouped by the school that offers it; each leads to the SB. Minors and graduate programs are left out.",
    "groups": [
        {
            "name": "School of Architecture and Planning",
            "source": {
                "label": "MIT Course Catalog, Undergraduate Degree Charts",
                "url": "https://catalog.mit.edu/degree-charts/"
            },
            "majors": [
                {
                    "name": "Architecture (Course 4)",
                    "degree": "SB"
                },
                {
                    "name": "Art and Design (Course 4-B)",
                    "degree": "SB"
                },
                {
                    "name": "Planning (Course 11)",
                    "degree": "SB"
                }
            ]
        },
        {
            "name": "School of Engineering",
            "source": {
                "label": "MIT Course Catalog, Undergraduate Degree Charts",
                "url": "https://catalog.mit.edu/degree-charts/"
            },
            "majors": [
                {
                    "name": "Aerospace Engineering (Course 16)",
                    "degree": "SB"
                },
                {
                    "name": "Archaeology and Materials as Recommended by the Department of Materials Science and Engineering (Course 3-C)",
                    "degree": "SB"
                },
                {
                    "name": "Artificial Intelligence and Decision Making (Course 6-4)",
                    "degree": "SB"
                },
                {
                    "name": "Biological Engineering (Course 20)",
                    "degree": "SB"
                },
                {
                    "name": "Chemical-Biological Engineering (Course 10-B)",
                    "degree": "SB"
                },
                {
                    "name": "Chemical Engineering (Course 10)",
                    "degree": "SB"
                },
                {
                    "name": "Chemical Engineering as Recommended by the Department of Chemical Engineering (Course 10-C)",
                    "degree": "SB"
                },
                {
                    "name": "Computer Science and Engineering (Course 6-3)",
                    "degree": "SB"
                },
                {
                    "name": "Electrical Engineering with Computing (Course 6-5)",
                    "degree": "SB"
                },
                {
                    "name": "Engineering (Course 1-ENG)",
                    "degree": "SB"
                },
                {
                    "name": "Engineering (Course 2-A)",
                    "degree": "SB"
                },
                {
                    "name": "Engineering (Course 10-ENG)",
                    "degree": "SB"
                },
                {
                    "name": "Engineering (Course 16-ENG)",
                    "degree": "SB"
                },
                {
                    "name": "Engineering (Course 22-ENG)",
                    "degree": "SB"
                },
                {
                    "name": "Materials Science and Engineering (Course 3)",
                    "degree": "SB"
                },
                {
                    "name": "Materials Science and Engineering (Course 3-A)",
                    "degree": "SB"
                },
                {
                    "name": "Mechanical and Ocean Engineering (Course 2-OE)",
                    "degree": "SB"
                },
                {
                    "name": "Mechanical Engineering (Course 2)",
                    "degree": "SB"
                },
                {
                    "name": "Nuclear Science and Engineering (Course 22)",
                    "degree": "SB"
                }
            ]
        },
        {
            "name": "School of Humanities, Arts, and Social Sciences",
            "source": {
                "label": "MIT Course Catalog, Undergraduate Degree Charts",
                "url": "https://catalog.mit.edu/degree-charts/"
            },
            "majors": [
                {
                    "name": "Anthropology (Course 21A)",
                    "degree": "SB"
                },
                {
                    "name": "Comparative Media Studies (CMS)",
                    "degree": "SB"
                },
                {
                    "name": "Economics (Course 14-1)",
                    "degree": "SB"
                },
                {
                    "name": "Global Studies and Languages (Course 21G)",
                    "degree": "SB"
                },
                {
                    "name": "History (Course 21H)",
                    "degree": "SB"
                },
                {
                    "name": "Humanities (Course 21)",
                    "degree": "SB"
                },
                {
                    "name": "Humanities and Engineering (Course 21E)",
                    "degree": "SB"
                },
                {
                    "name": "Humanities and Science (Course 21S)",
                    "degree": "SB"
                },
                {
                    "name": "Linguistics and Philosophy (Course 24-2)",
                    "degree": "SB"
                },
                {
                    "name": "Literature (Course 21L)",
                    "degree": "SB"
                },
                {
                    "name": "Mathematical Economics (Course 14-2)",
                    "degree": "SB"
                },
                {
                    "name": "Music (Course 21M)",
                    "degree": "SB"
                },
                {
                    "name": "Philosophy (Course 24-1)",
                    "degree": "SB"
                },
                {
                    "name": "Political Science (Course 17)",
                    "degree": "SB"
                },
                {
                    "name": "Science, Technology, and Society/Second Major (STS)",
                    "degree": "SB",
                    "note": "Taken only as a second major."
                },
                {
                    "name": "Theater Arts (Course 21T)",
                    "degree": "SB"
                },
                {
                    "name": "Writing (Course 21W)",
                    "degree": "SB"
                }
            ]
        },
        {
            "name": "Sloan School of Management",
            "source": {
                "label": "MIT Course Catalog, Undergraduate Degree Charts",
                "url": "https://catalog.mit.edu/degree-charts/"
            },
            "majors": [
                {
                    "name": "Business Analytics (Course 15-2)",
                    "degree": "SB"
                },
                {
                    "name": "Finance (Course 15-3)",
                    "degree": "SB"
                },
                {
                    "name": "Management (Course 15-1)",
                    "degree": "SB"
                }
            ]
        },
        {
            "name": "School of Science",
            "source": {
                "label": "MIT Course Catalog, Undergraduate Degree Charts",
                "url": "https://catalog.mit.edu/degree-charts/"
            },
            "majors": [
                {
                    "name": "Biology (Course 7)",
                    "degree": "SB"
                },
                {
                    "name": "Brain and Cognitive Sciences (Course 9)",
                    "degree": "SB"
                },
                {
                    "name": "Chemistry (Course 5)",
                    "degree": "SB"
                },
                {
                    "name": "Earth, Atmospheric, and Planetary Sciences (Course 12)",
                    "degree": "SB"
                },
                {
                    "name": "Mathematics (Course 18)",
                    "degree": "SB"
                },
                {
                    "name": "Mathematics with Computer Science (Course 18-C)",
                    "degree": "SB"
                },
                {
                    "name": "Physics (Course 8)",
                    "degree": "SB"
                }
            ]
        },
        {
            "name": "Interdisciplinary Programs",
            "source": {
                "label": "MIT Course Catalog, Undergraduate Degree Charts",
                "url": "https://catalog.mit.edu/degree-charts/"
            },
            "majors": [
                {
                    "name": "Chemistry and Biology (Course 5-7)",
                    "degree": "SB"
                },
                {
                    "name": "Climate System Science and Engineering (Course 1-12)",
                    "degree": "SB"
                },
                {
                    "name": "Computation and Cognition (Course 6-9)",
                    "degree": "SB"
                },
                {
                    "name": "Computer Science and Molecular Biology (Course 6-7)",
                    "degree": "SB"
                },
                {
                    "name": "Computer Science, Economics, and Data Science (Course 6-14)",
                    "degree": "SB"
                },
                {
                    "name": "Urban Science and Planning with Computer Science (Course 11-6)",
                    "degree": "SB"
                }
            ]
        }
    ]
};

export default majors;
